import Vue from 'vue';
import axios from 'axios';

export async function FetchChildrenData({ commit }, userId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${userId}/getChildren/`,
  })
    .then((response) => {
      commit(
        'setChildrenDate',
        response.data.map((o) => {
          return { ...o.child, child_enabled: o.child_enabled, parent_can_edit: o.parent_can_edit };
        }),
      );
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function GetGoalSetup({ commit }, userId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${userId}/get_goals_setup/`,
  })
    .then((response) => {
      commit('setGoalsSetup', response.data['daily_goal']);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function setParentGoals({ commit }, data) {
  await Vue.axios({
    method: 'PUT',
    url: `/parent/${data.userId}/set_goals_setup/`,
    data: {
      next_daily_goal: data.daily_goal,
    },
  })
    .then(() => {
      commit('cleanErrors');
      commit('setGoalsSetup', data.daily_goal);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function getParentChildrenOrder({ commit }, userId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${userId}/preferences/`,
  })
    .then((response) => {
      commit('setChildrenOrder', response.data['children_order']);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchChildChallengeOrder({ commit }, childId) {
  commit('cleanErrors');

  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/challenges_order/`,
  })
    .then((response) => {
      const resp = response.data['challenges_order'];
      commit('setChildChallengeOrder', resp);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function UpdateChildChallengeOrder({ commit }, { childId, challengesOrder }) {
  try {
    const { data: response } = await axios.post(`/child/${childId}/challenges_order/`, {
      challenges_order: challengesOrder,
    });
    const challenges_order = response['challenges_order'];
    commit('cleanErrors');
    commit('setChildChallengeOrder', challenges_order);
  } catch (error) {
    commit('error', error);
    throw new Error('Ups!, we have a problem when trying sort the challenges');
  }
}

export async function setParentChildrenOrder({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.userId}/children_order/`,
    data: {
      children_order: data.childrenOrder,
    },
  })
    .then(() => {
      commit('cleanErrors');
      commit('setChildrenOrder', data.childrenOrder);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function getParentFavoriteSkills({ commit }, userId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${userId}/preferences/`,
  })
    .then((response) => {
      commit('setFavoriteSkills', response.data['favorite_skill']);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function setParentFavoriteSkills({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.userId}/favorite_skill/`,
    data: {
      favorite_skill: data.favoriteSkill,
    },
  })
    .then(() => {
      commit('cleanErrors');
      commit('setFavoriteSkills', data.favoriteSkill);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function setParentChildrenEnable({ commit }, childId) {
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/enable/`,
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function setParentChildrenDisable({ commit }, childId) {
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/disable/`,
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error);
    });
}

function clinicianReportAdapter({ emails, child, copy_to }) {
  return {
    emails,
    child,
    copy_to
  };
}

export async function shareReport(_, { data, parentId }) {
  try {
    const clinicianReport = clinicianReportAdapter(data);
    const path = `/clinician_request/${parentId}/clinician_request/`;
    const { data: newClinician } = await Vue.axios({
      method: 'POST',
      url: path,
      data: clinicianReport
    });
    return newClinician
  } catch (error) {
    throw new Error('[Service]: Oops!, Error when try to share the reports..');
  }
}

export function parentGetCliniciansReport({ commit }, userId) {
  Vue.axios({
    method: 'GET',
    url: `/clinician_request/${userId}/clinician_request/`,
  })
    .then((response) => {
      commit('setChildsCliniciansReport', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export function setParentCliniciansReport({ commit }, data) {
  Vue.axios({
    method: 'PUT',
    url: `/clinician_request/${data.id}/set_clinician_request/`,
    data: {
      emails: data.emails,
      copy_to: data.copy_to,
      parent: data.parents
    }
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export function deleteParentCliniciansReport({ commit }, clinicianId) {
  Vue.axios({
    method: 'DELETE',
    url: `/clinician_request/${clinicianId}/delete_clinician_request/`
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

